var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegenerate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5112 24.3998C12.5706 24.3998 10.1779 22.007 10.1779 19.0665C10.1779 16.1259 12.5706 13.7332 15.5112 13.7332C18.4517 13.7332 20.8445 16.1259 20.8445 19.0665C20.8445 22.007 18.4517 24.3998 15.5112 24.3998ZM15.5112 14.3097C12.8878 14.3097 10.7544 16.4431 10.7544 19.0665C10.7544 21.6899 12.8878 23.8232 15.5112 23.8232C18.1346 23.8232 20.2679 21.6899 20.2679 19.0665C20.2679 16.4431 18.1346 14.3097 15.5112 14.3097Z",
    fill: "#081E56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.44764 2.68579H1.37526C0.836653 2.68579 0.400024 3.12924 0.400024 3.67627V21.5048C0.400024 22.0519 0.836653 22.4953 1.37526 22.4953H11.8016",
    stroke: "#081E56",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9238 14.4951V3.44752L14.8762 0.399902H4.97144C4.13335 0.399902 3.44763 1.08562 3.44763 1.92371V18.6856C3.44763 19.5237 4.13335 20.2094 4.97144 20.2094H10.6222",
    stroke: "#081E56",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8762 0.399902V3.44752H17.9238",
    stroke: "#081E56",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49524 4.97119H14.8762",
    stroke: "#081E56",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49524 7.25708H14.8762",
    stroke: "#081E56",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49524 9.54272H14.8762",
    stroke: "#081E56",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49524 11.8286H14.8762",
    stroke: "#081E56",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49524 14.114H14.1143",
    stroke: "#081E56",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62219 16.3999H11.0666",
    stroke: "#081E56",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0438 19.1553C13.0438 17.8088 14.1313 16.7472 15.4519 16.7472C15.9439 16.7472 16.4099 16.9026 16.8242 17.1615L16.384 17.2133C16.2546 17.2392 16.151 17.3686 16.151 17.4981C16.1769 17.6276 16.2805 17.7312 16.4099 17.7312H16.4358L17.3939 17.6017C17.4198 17.6017 17.4716 17.6017 17.4975 17.5758C17.5493 17.5758 17.6269 17.524 17.6528 17.4722C17.7046 17.4204 17.7046 17.3427 17.7046 17.291L17.5752 16.3329C17.5493 16.2034 17.4198 16.0999 17.2903 16.0999C17.1609 16.1257 17.0573 16.2552 17.0573 16.3847L17.1091 16.7213C16.6171 16.3847 16.0215 16.1775 15.426 16.1775C13.7947 16.1775 12.5 17.4981 12.5 19.1035C12.5 19.3107 12.5259 19.5437 12.5777 19.7509C12.6036 19.8803 12.7071 19.958 12.8366 19.958C12.8625 19.958 12.8625 19.958 12.8884 19.958C13.0179 19.9321 13.1214 19.7768 13.0956 19.6473C13.0697 19.5178 13.0438 19.3366 13.0438 19.1553Z",
    fill: "#081E56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4038 18.3784C18.3779 18.2489 18.2225 18.1453 18.0931 18.1712C17.9636 18.1971 17.86 18.3525 17.8859 18.482C17.9118 18.6632 17.9377 18.8186 17.9377 18.9998C17.9377 20.3463 16.8502 21.4079 15.5296 21.4079C15.0376 21.4079 14.5715 21.2526 14.1572 20.9936L14.5974 20.9419C14.7269 20.916 14.8305 20.7865 14.8305 20.657C14.8046 20.5276 14.6751 20.424 14.5456 20.424L13.5876 20.5534C13.5617 20.5534 13.5099 20.5534 13.484 20.5793C13.4322 20.5793 13.3545 20.6311 13.3286 20.6829C13.2769 20.7347 13.2769 20.8124 13.2769 20.8642L13.4063 21.8222C13.4322 21.9517 13.5358 22.0553 13.6653 22.0553H13.6912C13.8206 22.0294 13.9242 21.8999 13.9242 21.7704L13.8724 21.4338C14.3644 21.7704 14.9599 21.9776 15.5555 21.9776C17.1868 21.9776 18.4815 20.657 18.4815 19.0516C18.4815 18.7927 18.4556 18.5855 18.4038 18.3784Z",
    fill: "#081E56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegenerate);
export default __webpack_public_path__ + "static/media/regenerate.863ed818edf35d8fe6ea1b67b56c4b8c.svg";
export { ForwardRef as ReactComponent };